export enum RewardTypes {
  Points = "Points",
  Coupon = "Coupon",
  FreeItem = "FreeItem",
  Discount = "Discount",
  Shipping = "Shipping",
}

export enum RewardRuleAttributeNames {
  CartItem = "CartItem",
  CartItemValue = "CartItemValue",
  CartItemQuantity = "CartItemQuantity",
  CartTotalValue = "CartTotalValue",
  ConsumerProfileAudience = "ConsumerProfileAudience",
  ConsumerProfileDateOfBirth = "ConsumerProfileDateOfBirth",
  RewardStartDate = "RewardStartDate",
  RewardEndDate = "RewardEndDate",
}

export enum RewardRuleAttributeValueDescriptions {
  Percentage = "Percentage",
  Sku = "Sku",
  Quantity = "Quantity",
  Monetary = "Monetary",
  ScheduleDate = "ScheduleDate",
  ProductURN = "ProductURN",
}

export enum RewardRuleEffects {
  AddDiscount = "AddDiscount",
  AddPoints = "AddPoints",
  AddFreeItem = "AddFreeItem",
  FreeShipping = "FreeShipping",
  CanApplyNonExpiredReward = "CanApplyNonExpiredReward",
  CanApplyLiveReward = "CanApplyLiveReward",
  CashBack="CashBack",
  Points="Points",
  Shipping="Shipping"
}

export enum RewardRuleAttributeCriteria {
  EqualTo = "EqualTo",
  NotEqualTo = "NotEqualTo",
  GreaterThanOrEqualTo = "GreaterThanOrEqualTo",
  GreaterThan = "GreaterThan",
  LessThan = "LessThan",
  LessThanOrEqualTo = "LessThanOrEqualTo",
  In = "In",
  NotIn = "NotIn",
}
